import React, {useEffect, useState} from "react";
import {InputAdornment, TextField} from "@mui/material";
import {produce} from "immer";
const ProjectDetailValidatedTextField = ({   productItem,
                                           field,
                                           draftQuoteDetail,
                                           setDraftQuoteDetail,
                                           disabled, 
                                           id, 
                                           validator, 
                                           onChange 
}) => 
{
    const [value, setValue] = useState(() => {
        const id =  draftQuoteDetail.productItemId ?? draftQuoteDetail.productGroupId;
        if (id) {
            return draftQuoteDetail.quoteDetailFieldValues?.find(detail => 
                detail.productItemId === productItem.id)?.fields
                    .find(updatedField => updatedField.fieldId === field.id)?.value;
        }
        return null;
    });
    const [error, setError] = useState(false);

    useEffect(() => {
        setValue(() => {
            const id = draftQuoteDetail.productItemId ?? draftQuoteDetail.productGroupId;
            if (id) {
                return draftQuoteDetail.quoteDetailFieldValues?.find(detail =>
                    detail.productItemId === productItem.id)?.fields
                    .find(updatedField => updatedField.fieldId === field.id)?.value;
            }
            return null;
        });
    }, [draftQuoteDetail])
    
    const handleChange = e => {
        const newValue = e.target.value;
        const errorMessage = validator(newValue);
        setValue(newValue);
        setError(errorMessage);
        onChange(!errorMessage);
        
        setDraftQuoteDetail(prevState => produce(prevState, draft => {
            const fieldToUpdate = draft.quoteDetailFieldValues
                .find(detail => detail.productItemId === productItem.id)
                ?.fields.find(fld => fld.fieldId === field.id);
            
            if (fieldToUpdate) {
                fieldToUpdate.value = newValue;
            }
        }));
    };
    
    return (
        <TextField
            id={draftQuoteDetail.id !== undefined
                ? `${draftQuoteDetail.id}-${field.id}`
                : `${draftQuoteDetail.tempId}-${field.id}`}
            disabled={disabled}
            key={id}
            error={!!error}
            required
            helperText={error}
            label={field.displayName}
            sx={{
                width: {xs: '250px !important', md: '300px !important'},
            }}
            slotProps={{
                input: { endAdornment: <InputAdornment position="end">{field.uom}</InputAdornment> }
            }}
            value={value}
            onChange={handleChange}
        />
    );
};

export default ProjectDetailValidatedTextField;